import * as React from 'react'

interface Props {
  children: React.ReactElement<any>
}

export class Terrific extends React.Component<Props> {
  private refElement = React.createRef<HTMLElement>()

  private get terrific() {
    return (window as any).uxcPatternApi.terrific
  }

  componentDidMount() {
    this.terrific.startNode(this.refElement.current)
  }

  componentWillUnmount() {
    this.terrific.stopNode(this.refElement.current)
  }

  render() {
    return React.cloneElement(this.props.children, { ref: this.refElement })
  }
}
